// 常规巡检类型
import React, { useEffect, useState, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import {
  PlusOutlined, SearchOutlined, MenuOutlined, DeleteOutlined, GlobalOutlined, EditOutlined,
  CaretRightOutlined, NodeCollapseOutlined, RotateLeftOutlined, NodeExpandOutlined, NodeIndexOutlined,
  RotateRightOutlined, ExclamationCircleFilled, QuestionCircleOutlined
} from '@ant-design/icons';
import dayjs from 'dayjs';
import { Card, Button, Dropdown, Input, Space, Table, message as AntMessage, App, Pagination, Drawer, Form, InputNumber, theme, Select, Popconfirm, Switch, Tag } from 'antd';
import { GetRoutesList, ImportPoint, ImportRoute, DelRoutes, SetRoutes, AirTemporary, M3Temporary, IdentifyStakeFun, ExportWaypointsFun } from '@/server/Routine/list.js'
import { getFlyRouteApi, setRoutesApi, delRoutesApi, setStatusApi, derivedInfoApi, temporaryExecutionApi } from '@/server/new_pipeline_inspection.js'
import { getDockElectricityApi } from '@/server/home.js'
import { basicPath } from '@/router/config';//引入路由基础路径
import './index.css'
const { TextArea } = Input;

function ShippingLine () {
  const { token: { colorTextPlaceholder, }, } = theme.useToken(); //获取主题颜色
  const [messageApi, contextHolder] = AntMessage.useMessage();
  const { message, modal } = App.useApp();
  const { confirm } = modal;
  const [statusLoading, setStatusLoading] = useState(false)//状态loading
  //type 1 常规巡检 2 高危巡检 3 采集读数
  const location = useLocation();//接受传值数据
  const token = localStorage.getItem('dock_token');
  const [loading, setLoading] = useState(false);

  //表格筛选条件
  const [search, setSearch] = useState({
    access_token: token,
    page: 1,
    perpage: 10,
    type: ''
  });
  const [cur, setCur] = useState(1);//当前页
  const [page, setPage] = useState(10);//每页多少条
  const [total, setTotal] = useState(0);//总条数
  const [AirportPermissionsArrName, setAirportPermissionsArrName] = useState([])//权限  
  const [AirportPermissionsArr, setAirportPermissionsArr] = useState([])//权限
  const searchInput = useRef(null);//搜索框数据
  const [data, setData] = useState([]);//表格数据
  const [choose_id, setChooseId] = useState('');//当前选择的管线id

  const [modal_show, setDrawerShow] = useState(false);//是否显示弹窗
  const [modal_title, setModalTitle] = useState('新增');//弹窗标题
  const [form] = Form.useForm();
  const [btn_loading, setBtnLoading] = useState(false);//按钮加载

  const [airfield_list, setAirfieldList] = useState([{ value: '1', name: '机场1' }, { value: '2', name: '机场2' }]);//机场数据

  const [dockNameType, setDockNameType] = useState([])

  const ws = useRef(null);//ws 对象
  const hasAirList = useRef(false)//机场是否在线

  //表格头搜索框
  const SearchProps = (dataIndex, text) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8, }} onKeyDown={(e) => e.stopPropagation()} >
        <Input
          ref={searchInput}
          placeholder={`搜索 ${text}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(confirm)} //回车搜索
          style={{ marginBottom: 8, display: 'block', }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(confirm)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, }}
          >
            搜索
          </Button>
          <Button
            onClick={() => handleReset(clearFilters, confirm)}
            size="small"
            style={{ width: 90, }}
          >
            重置
          </Button>

        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1890ff' : undefined,
        }}
      />
    ),//图标
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);//自动获得焦点
      }
    },
  });

  //表格头
  const columnsList = () => {
    let perm = localStorage.getItem('dock_AirportPermissionsArr') ? [...JSON.parse(localStorage.getItem('dock_AirportPermissionsArr'))] : [];
    const columns = [
      {
        title: 'ID',
        dataIndex: 'id',
        // sorter: () => { },
      },
      {
        title: '航线名称',
        dataIndex: 'title',
        render: (text, record) => {
          return (
            <div>{text}</div>
          )
        },
        // ...SearchProps('title', '航线名称'),
      },
      {
        title: '总里程(km)',
        dataIndex: 'length',
        sorter: () => { },
      },
      {
        title: '机场',
        dataIndex: 'dock_id',
        render: (text, record) => {
          let showtext = dockNameType.find(res => res.value === text)?.text
          return (
            showtext
              ? <div>{showtext}</div>
              : (
                <Tag color="error">
                  未找到
                </Tag>
              )
          )
        },
        filters: dockNameType,
        filterMultiple: false,
      },
      // {
      //   title: '最新执行时间',
      //   dataIndex: 'time',
      //   render: (text, record) => {
      //     return text
      //       ? (
      //         <div>
      //           <span className='marR8'>{text.substring(0, 10)}</span>
      //           <span className='opa45'>{text.substring(11, 16)}</span>
      //         </div>
      //       )
      //       : <div style={{ color: colorTextPlaceholder }}>-</div>
      //   },
      //   sorter: () => { },
      // },
      // {
      //   title: '编辑人',
      //   dataIndex: 'username',
      //   render: (text, record) => {
      //     return (
      //       text
      //         ? (<span className='opa45'>{text}</span>)
      //         : <div style={{ color: colorTextPlaceholder }}>-</div>
      //     )
      //   },
      // },
      // {
      //   title: '编辑时间',
      //   dataIndex: 'update_time',
      //   render: (text, record) => {
      //     return text
      //       ? (
      //         <div>
      //           <span className='opa45 marR8'>{text.substring(0, 10)}</span>
      //           <span className='opa45'>{text.substring(11, 16)}</span>
      //         </div>
      //       )
      //       : <div style={{ color: colorTextPlaceholder }}>-</div>
      //   },
      //   // sorter: () => { },
      // },
      {
        title: '巡检覆盖对象',
        dataIndex: 'des',
        render: (text, record) => {
          return (
            text
              ? (<div>{text}</div>)
              : <div style={{ color: colorTextPlaceholder }}>-</div>
          )
        },
        ...SearchProps('', '巡检覆盖对象'),
      },
      {
        title: '地图',
        key: 'map',
        align: 'center',
        width: 120,
        render: (text, record) => {
          if (AirportPermissionsArrName.indexOf(`RoutesInfo_${search.type}`) > -1) {
            return (
              <div
                style={{ display: (Number(record.state) === 1 ? '' : 'none') }}
                onClick={() => { ToMap(record) }}
              >
                <GlobalOutlined className='pointer col_primary' style={{ width: '16px', height: '16px' }} />
              </div>
            )
          } else {
            return (<GlobalOutlined style={{ width: '16px', height: '16px' }} />)
          }
        },
      },
      {
        title: '操作',
        dataIndex: '',
        align: 'center',
        width: 120,
        render: (text, record) => {
          return (
            <Dropdown
              trigger={['click']}
              menu={dropDownOption(record)}
              placement="bottom"
            >
              <MenuOutlined className='pointer col_primary' />
            </Dropdown>
          )
        }
      },
    ];

    if (search.type === 7) {
      columns.splice(columns.length - 2, 0,
        {
          title: '绘制警戒线',
          width: 110,
          isShow: perm.indexOf(513) >= 0,
          align: 'center',
          render: (text, record) => {
            return (
              <Switch
                loading={statusLoading}
                defaultChecked={record.cordon}
                size='small'
                onClick={(e) => {
                  setStatus(record, e)
                }}
              />
            )
          },
        },)
    }
    return columns
  }

  //表格操作列表
  const dropDownOption = (data) => {
    const typeArr = [//常规
      {
        key: 3,
        permissions: `Temporary_${search.type}`,
        label: (
          <div onClick={() => {
            let restartDockArr = JSON.parse(localStorage.getItem('dock_restartDockArr')) || []
            if (restartDockArr?.find(e => e.dockId === data.dock_id)?.time && (dayjs().valueOf() - restartDockArr?.find(e => e.dockId === data.dock_id)?.time) < (120 * 1000)) {
              message.warning('当前机场重启小于两分钟，请稍等片刻')
            } else {
              getDockElectricity(data);
            }
          }}>
            <CaretRightOutlined className='marR10' /> 临时执行
          </div>
        ),
      },
      {
        key: 2,
        permissions: `RoutesPoint_Import_${search.type}`,
        label: (
          <div onClick={() => {
            setChooseId(data.id);
            document.getElementById('importPoint').click();
          }}>
            <NodeCollapseOutlined className='marR10' /> 上传管线
          </div>
        ),
      },
      {
        key: 4,
        permissions: `RoutesMark_Import_${search.type}`,
        label: (
          <div onClick={() => {
            setChooseId(data.id);
            document.getElementById('identifyStake').click();
          }}>
            <RotateLeftOutlined className='marR10' /> 上传标识桩
          </div>
        ),
      },
      {
        key: 5,
        permissions: `Routes_PointExport_${search.type}`,
        label: (
          <div onClick={() => { exportData(1, data.id) }}>
            <NodeExpandOutlined className='marR10' /> 导出管线
          </div>
        ),
      },
      {
        key: 6,
        permissions: `Routes_PointExport_${search.type}`,
        label: (
          <div onClick={() => { exportData(2, data.id) }}>
            <NodeIndexOutlined className='marR10' /> 导出航点
          </div>
        ),
      },
      {
        key: 7,
        permissions: `Routes_PointExport_${search.type}`,
        label: (
          <div onClick={() => { exportData(3, data.id) }}>
            <RotateRightOutlined className='marR10' /> 导出标识桩
          </div>
        ),
      },
      {
        key: 1,
        permissions: `RoutesInfo_Edit_${search.type}`,
        label: (
          <div
            onClick={() => {
              setChooseId(data.id);
              setDrawerShow(true);
              setModalTitle('编辑');
              form.setFieldsValue({
                title: data.title,
                des: data.des,
                dock_id: dockNameType.find(res => res.value === data.dock_id)?.text ? data.dock_id : `原机场ID为:${data.dock_id}`,
                length: Number(data.length)
              }); //表单赋值
            }}
          >
            <EditOutlined className='marR10' /> 修改
          </div>
        ),
      },
      {
        key: 8,
        permissions: `RoutesInfo_Del_${search.type}`,
        label: (
          <div>
            <Popconfirm
              title="是否删除？"
              icon={
                <QuestionCircleOutlined
                  style={{ color: 'red', }}
                />
              }
              onConfirm={async () => {
                await DelRoutesFun(data.id)
              }}
              onCancel={() => { }}
              okText="删除"
              cancelText="取消"
            >
              <DeleteOutlined className='marR10' /> 删除
            </Popconfirm>
          </div>

        ),
      },
    ]

    const newPowerGrid = [//新电网
      {
        key: 1,
        permissions: 519,
        label: (
          <div
            onClick={() => {
              let restartDockArr = JSON.parse(localStorage.getItem('dock_restartDockArr')) || []
              if (restartDockArr?.find(e => e.dockId === data.dock_id)?.time && (dayjs().valueOf() - restartDockArr?.find(e => e.dockId === data.dock_id)?.time) < (120 * 1000)) {
                message.warning('当前机场重启小于两分钟，请稍等片刻')
              } else {
                getDockElectricity(data);
              }
            }}
          >
            <CaretRightOutlined className='marR10' /> 临时执行
          </div>
        ),
      },
      {
        key: 2,
        permissions: 516,
        label: (
          <div onClick={() => { exportData(2, data.id) }}>
            <NodeIndexOutlined className='marR10' /> 导出航点
          </div>
        ),
      },
      {
        key: 3,
        permissions: 507,
        label: (
          <div
            onClick={() => {
              console.log('data', data);
              setChooseId(data.id);
              setDrawerShow(true);
              setModalTitle('编辑');
              form.setFieldsValue({
                fly_name: data.fly_name,
                dock_id: data.dock_id || null,
                fly_len: Number(data.fly_len)
              }); //表单赋值
            }}
          >
            <EditOutlined className='marR10' /> 修改
          </div>
        ),
      },
      {
        key: 4,
        permissions: 510,
        label: (
          <div onClick={() => { DelRoutesFun(data.id) }}>
            <DeleteOutlined className='marR10' /> 删除
          </div>
        ),
      },
    ]

    let arr = []
    if (search.type === 7) {
      newPowerGrid.forEach((item) => {
        if (AirportPermissionsArr.indexOf(item.permissions) > -1 || item.permissions === '') {
          arr.push(item)
        }
        if (arr.length > 1 && arr[arr.length - 1].key === 4) {
          arr.splice(-1, 0, { type: 'divider' })
        }
      })
      return { items: arr }
    } else {
      for (let i = 0; i < typeArr.length; i++) {
        let item = typeArr[i];
        if (AirportPermissionsArrName.indexOf(item.permissions) > -1 || item.permissions === '') {
          if (item.key === 1) {
            arr.push({ type: 'divider' });
          }
          arr.push(item);
          if (item.key === 3 && typeArr[i + 1].key !== 1) {
            arr.push({ type: 'divider' });
            continue
          }

        }
      }
    }

    return { items: arr }
  }

  //输入框搜索
  const handleSearch = (confirm) => {
    confirm()
  };

  //重置
  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
  };

  const setStatus = async (record, type) => { //修改警戒线状态
    setStatusLoading(true)
    let obj = {
      access_token: token,
      fr_ids: record.id,
      FieldName: 'cordon',
      FieldValue: type ? 1 : 0
    }
    let res = await setStatusApi(obj)
    if (res.ret !== 200) {
      message.warning(res.msg || '服务器开了小差，请重试');
      setStatusLoading(false)
      return;
    }
    setStatusLoading(false)
  }


  //获取表格数据
  const getTableData = async (obj) => {
    setLoading(true);
    let res = await GetRoutesList(obj);
    if (res.ret !== 200) {
      message.warning(res.msg || '服务器开了小差，请重试');
      return;
    }
    let arr = res.data.items.length > 0 ? res.data.items.map((item) => {
      return {
        ...item, dock_id: Number(item.dock_id)
      }
    }) : [];
    setData(arr);
    setTotal(res.data.total);

    let dictionary = res.data?.sjzd?.map((item) => {
      return {
        label: item.name,
        value: Number(item.id),
      }
    });

    let dock = res.data?.sjzd?.map((item) => {
      return {
        text: item.name,
        value: Number(item.id),
      }
    });

    setDockNameType(dock)
    setAirfieldList(dictionary)
    setLoading(false);
  }

  //跳转至管线编辑
  const ToMap = async (record) => {
    window.open(`${basicPath}/MapInspection?${record.id}&${search.type}&${record.dock_id}&${record.docklongitude_w84 || 0}&${record.docklatitude_w84 || 0}`);
  }

  //新增|修改管线
  const onFinish = async (values) => {
    setBtnLoading(true);
    let obj = {
      ...values,
      access_token: token,
      type: search.type,
      dock_id: typeof (values.dock_id) === 'number' ? values.dock_id : Number(values.dock_id.split(':')[1]),
    }
    if (choose_id) { obj.id = choose_id; }
    let res = await SetRoutes(obj);
    setBtnLoading(false);
    if (res.ret !== 200) {
      message.warning(res.msg || '服务器开了小差，请重试');
      return;
    }
    message.success(choose_id ? '编辑成功' : '新增成功');
    CloseDrawer();
    getTableData(search);

  };

  //临时执行
  const TemporaryFun = async (id) => {
    let obj = {
      access_token: token,
      id: id
    }
    let res
    if (localStorage.getItem('dock_companyType') === '1') {
      messageApi.open({
        type: 'loading',
        content: '正在准备临时执行...',
        duration: 0,
      });
      res = await M3Temporary(obj)
    } else if (localStorage.getItem('dock_companyType') === '2') {
      messageApi.open({
        type: 'loading',
        content: '正在准备临时执行...',
        duration: 0,
      });
      res = await AirTemporary(obj)
    } else {
      message.warning('暂未获取到当前角色所在公司')
      return
    }
    messageApi.destroy();
    if (res.ret !== 200) {
      message.warning(res.msg || '服务器开了小差，请重试');
      return;
    }
    message.success('执行成功');
    getTableData(search);
  }

  //删除
  const DelRoutesFun = async (id) => {
    let res = await DelRoutes({
      access_token: token,
      id: id
    })
    if (res.ret !== 200) {
      message.warning(res.msg || '服务器开了小差，请重试');
      return;
    }
    if (total > 10 && total % 2 === 1 && search.page > 1) {
      let num = search
      num.page = num.page - 1
      setSearch({ ...num })
      setCur(num - 1)
    }
    message.success('删除成功');
    getTableData(search);
  }

  //关闭弹窗
  const CloseDrawer = () => {
    setDrawerShow(false)
    form.resetFields();
    setChooseId('');
  }

  //上传坐标
  const importData = async (val) => {
    let obj = {
      access_token: token,
      id: val.id,
      type: '',//WGS84 GCJ
      file: val.file,
    }
    messageApi.open({
      type: 'loading',
      content: '正在上传管线...',
      duration: 0,
    });
    const res = await ImportPoint(obj);
    document.getElementById('importPoint').value = '';
    messageApi.destroy();
    if (res.ret !== 200) {
      message.warning(res.msg || '服务器开了小差，请重试');
      return;
    }
    message.success('上传成功');
    getTableData(search);
  };

  //上传航线
  const importRouteData = async (val) => {
    let obj = {
      access_token: token,
      id: val.id,
      type: '',//WGS84 GCJ
      file: val.file,
    }
    const res = await ImportRoute(obj);
    document.getElementById('importRoute').value = '';
    if (res.ret !== 200) {
      message.warning(res.msg || '服务器开了小差，请重试');
      return;
    }
    message.success('上传成功');
    getTableData(search);
  };

  //上传标识桩
  const importIdentifyStake = async (val) => {
    // var data = new FormData();
    // // 创建一个表单数据
    // data.append("access_token", token);
    // data.append("id", val.id);
    // data.append("file", val.file);
    let res = await IdentifyStakeFun({
      access_token: token,
      id: val.id,
      file: val.file
    });
    document.getElementById('identifyStake').value = '';
    if (res.ret !== 200) {
      message.warning(res.msg || '系统出错了');
      return;
    }
    message.success('上传成功');
    getTableData(search);
  };

  //导出管线、航点、标识桩
  const exportData = async (type, id) => {
    let res = await ExportWaypointsFun({
      access_token: token,
      id: id,
      type: type
    });
    if (res.ret !== 200) {
      message.warning(res.msg || '导出失败，请稍后重试~');
      return;
    }
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = res.data
    document.body.appendChild(link);
    link.click();
    // 释放的 URL 对象以及移除 a 标签
    URL.revokeObjectURL(link.href);
    document.body.removeChild(link);
    message.success('导出成功~')
  }

  const getAirportLive = async (url, dockSn) => { //机场是否在线
    let obj = {}
    let airTime = 1
    let airNum = 1
    ws.current = new WebSocket(url);

    ws.current.onopen = (msg) => {//链接开启
      console.log("链接成功", msg);
    };

    ws.current.onmessage = e => {// 成功获取数据
      try {
        setTimeout(() => {
          setLoading(false)
        }, 1000);
        let data = JSON.parse(e.data)

        if (data.biz_code === 'dock_osd' && data.data.sn === dockSn) {//机场
          airTime = dayjs().valueOf()
          if (data.data.host && JSON.stringify(data.data.host) !== '{}') {
            hasAirList.current = true
            return true
          }
          if (airNum === 1 && obj.longitude) {
            airNum += 1
          }
        }
      } catch (error) {
        // message.warning('当前机场状态错误，请确认机场是否正确链接')
      }
    }

    ws.current.onerror = (msg) => {//报错信息
      // console.log('链接出错', msg)
    }

    ws.current.onclose = (msg) => {//链接断开
      console.log('链接断开');
      if (ws.current) {
        ws.current.close()
        ws.current = null
      }
      airNum = 1
      clearInterval(settime)
      return false
    };
    // 3秒一次检查当前ws传回来的数据是否还在
    let settime = setInterval(() => {
      let airTimes = Math.abs(Math.floor(dayjs().valueOf() - airTime) / 1000)
      if (airTimes > 3) { return false } else { return true }
    }, 2000);
  }

  //获取机场电量
  const getDockElectricity = async (data) => {
    setLoading(true)
    if (ws.current) {
      ws.current.close()
      ws.current = null
    }
    let params = {
      access_token: token,
      dock_id: data.dock_id
    }
    let res = await getDockElectricityApi(params);
    if (res.ret !== 200) {
      message.warning(res.msg || '数据跑丢了~');
      setLoading(false);
      return;
    }

    if (!res.data.ws_host || !res.data.dockSn) {
      message.warning('暂未获取到ws地址或机场编号');
      setLoading(false)
      return;
    }
    let isLive = await getAirportLive(res.data.ws_host, res.data.dockSn)

    setTimeout(() => {
      if (isLive || hasAirList.current) {//机场是否存在
        setLoading(false)
        confirm({
          title: data.title,
          icon: <ExclamationCircleFilled />,
          content: '当前无人机电量为' + res.data.battery_percent + '%，是否起飞',
          onOk () {
            TemporaryFun(data.id);
            if (ws.current) {
              ws.current.close()
              ws.current = null
            }
          },
          onCancel () {
            if (ws.current) {
              ws.current.close()
              ws.current = null
            }
          }
        });
      } else {
        setLoading(false)
        confirm({
          title: '电量提醒',
          icon: <ExclamationCircleFilled />,
          content: `当前无人机电量为${res.data.battery_percent}%但3s内未获取到机场信息`,
          okText: '已确认机场开启，可以起飞',
          onOk () {
            TemporaryFun(data.id);
            if (ws.current) {
              ws.current.close()
              ws.current = null
            }
          },
          onCancel () {
            if (ws.current) {
              ws.current.close()
              ws.current = null
            }
          }
        });
      }
    }, 3000);

  }

  useEffect(() => {
    let obj = { ...search };
    // 根据url地址确定当前属于哪个类型的记录
    switch (location.pathname) {
      case '/routine_list_conduit'://管道
        obj.type = 1;
        break;
      case '/routine_list_powerGrid'://电网
        obj.type = 7;
        break;
      case '/routine_list_powerGrid_new'://新_电网
        obj.type = 11;
        break;
      default:
        break;
    }

    setSearch({ ...obj });
    getTableData(obj);
    setTimeout(() => {
      setAirportPermissionsArrName(localStorage.getItem('dock_AirportPermissionsArrName') ? [...JSON.parse(localStorage.getItem('dock_AirportPermissionsArrName'))] : [])
      setAirportPermissionsArr(localStorage.getItem('dock_AirportPermissionsArr') ? [...JSON.parse(localStorage.getItem('dock_AirportPermissionsArr'))] : [])
    }, 1000);
    //eslint-disable-next-line
  }, [location.pathname])

  return (
    <>
      {contextHolder}
      <Card style={{ border: 0 }} className="mar24" styles={{ body: { padding: '24px' } }} id='none_arrow'>
        <div className="flex_row pdRL12 pdB16 align_center">
          <div className="fs16 fw500 col_main_text marR12">航线列表</div>
          <div className="fSize14 col_primary pointer" style={{ display: search.type === 1 ? '' : 'none' }}
            onClick={() => { window.open(basicPath + '/shipping_line_overview'); }}
          >
            航线总览
          </div>
          <div className="fSize14 marL12 col_primary pointer" style={{ display: AirportPermissionsArrName.indexOf(`Create_RoutesInfo_Get_${search.type}`) > -1 ? '' : 'none' }}
            onClick={() => {
              // window.open(basicPath + '/shipping_line_build_segment?');
              window.open(`${basicPath}/shipping_line_build_segment?${search.type}`)
            }}
          >
            批量生成单元段
          </div>
          <div className='flex_auto'></div>

          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => {
              if (AirportPermissionsArrName.indexOf(`RoutesInfo_Add_${search.type}`) > -1) {
                setChooseId('');
                setDrawerShow(true);
                setModalTitle('新增');
                form.setFieldsValue({
                  dock_id: airfield_list.length > 0 ? airfield_list[0].value : null,
                  length: null
                });
              } else {
                message.warning('暂无权限！')
              }
            }}
          >
            新增
          </Button>
        </div>
        <Table
          columns={columnsList()}
          dataSource={data}
          pagination={false}
          loading={loading}
          rowKey='id'
          onChange={(pagination, filters, sorter) => {
            let obj = { ...search };

            obj.page = 1;
            setCur(1);
            if (sorter && sorter.order) {
              let text = sorter.field + ' ';
              let ord = sorter.order === 'ascend' ? 'ASC' : 'DESC';
              obj.order = text + ord;
            } else {
              obj.order = '';
            }
            for (let i in filters) {
              let val = filters[i];
              if (val) {
                obj[i] = filters[i].join(',');
              } else {
                obj[i] = ''
              }
            }
            setSearch({ ...obj });
            getTableData({ ...obj })
          }}
        >
        </Table>

        <div className='pdT16'>
          <Pagination align='end' current={cur} pageSize={page} total={total} showTotal={total => `共 ${total} 条数据`}
            onChange={
              (current, pageSize) => { //选择当前页后执行
                setCur(current);
                setPage(pageSize);
                let obj = { ...search };
                obj.limit = pageSize;
                obj.page = current;
                setSearch({ ...obj });
                getTableData(obj);
              }
            } />
        </div>

        {/* 新增|编辑 弹窗 */}
        <Drawer
          title={modal_title}
          open={modal_show}
          width={256}
          footer={null}
          maskClosable={false}
          onClose={CloseDrawer}
          extra={
            <Button
              type='primary'
              loading={btn_loading}
              onClick={() => { form.submit() }}
            >
              提交
            </Button>
          }
        >
          <Form form={form} name='form' layout="vertical" onFinish={onFinish} style={{ marginTop: '12px' }}>
            <Form.Item label="航线名称" name="title" rules={[{ required: true, message: '请输入单元名称', }, { pattern: /^.{0,20}$/, message: '名称不能超过20字符', }]}>
              <Input placeholder="-" />
            </Form.Item>
            <Form.Item label="总里程(km)" name="length" hidden={choose_id ? false : true}
              rules={[{ required: choose_id ? true : false, message: '请输入单元名称', }]}>
              <InputNumber className='wid100' placeholder="-" />
            </Form.Item>

            <Form.Item
              label="机场"
              name="dock_id"
              rules={[{ required: true, message: '请选择机场', }]}
            >
              <Select
                placeholder='机场'
                style={{ width: '100%', }}
                options={airfield_list}
              />
            </Form.Item>
            <Form.Item label="巡检覆盖对象" name="des">
              <TextArea placeholder="-" />
            </Form.Item>
          </Form>
        </Drawer>

        <input id="importPoint" type="file" accept=".xls,.xlsx" hidden={true} onChange={(e) => {
          importData({ id: choose_id, file: e.target.files[0] })
        }}
        />
        <input id="importRoute" type="file" accept=".kmz," hidden={true} onChange={(e) => {
          importRouteData({ id: choose_id, file: e.target.files[0] })
        }}
        />
        {/* 上传标识桩 */}
        <input id="identifyStake" type="file" accept=".xls,.xlsx" hidden={true} onChange={(e) => {
          importIdentifyStake({ id: choose_id, file: e.target.files[0] })
        }}
        />
      </Card >
    </>
  )
}
export default ShippingLine